import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import './style.css';

const CloseIcon = ({ onClick }) => {
    return <FontAwesomeIcon className="close-icon" icon="times" onClick={onClick} />;
};

export default CloseIcon;
